import "./new-group-name-modal.scss";
import React, {Dispatch, SetStateAction, useState} from "react";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {WordBinGroupType} from "../../../../types";
import api from "../../../../api";

function NewGroupNameModal({
                               setShowGroupName,
                               setWordBinGroups,
                                clientId
                              }: {
    setShowGroupName: Dispatch<SetStateAction<boolean>>,
    setWordBinGroups: Dispatch<SetStateAction<any>>
    clientId:number
}) {

    const [nameValue,setNameValue]=useState<string>("");
  //  const newGroup: WordBinGroupType={} as WordBinGroupType;
    const changeNameValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setNameValue(value);
    }


    const confirmGroupName=()=>{
            if(nameValue==="") {
                /*NotificationStore.addNotification({
                    title: "",
                    message: "Please enter a name!",
                    type: "warning",                 // 'default', 'success', 'info', 'warning'
                    container: 'top-center',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                        duration: 4000
                    }
                })*/
            return;
            }

            api.reactionLists.addGroup(clientId,nameValue).then(
               setWordBinGroups
            )
            setShowGroupName(false);
    }
    return (
        <>
            <div id={"new-group-name-modal"}>
                    <p className={"new-group-name-modal-label"}>
                        <span>
                            <FontAwesomeIcon icon={faQuestionCircle} />
                            <i  >Please enter the name of the group:</i>
                        </span>
                    </p>

                    <input value={nameValue} onInput={changeNameValue}></input>

                    <div id={"btn-split-new-group"}>
                        <button onClick={()=>setShowGroupName(false)} id={"button-cancel-new-group"}>
                            Cancel
                        </button>
                        <button onClick={confirmGroupName}>
                            Confirm
                        </button>
                    </div>
            </div>
        </>)
}

export default NewGroupNameModal;
